export default __webpack_public_path__ + "static/Plots0067-c2bab7617acc29e80cd2ee01daef5b53.jpg";